import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { useProduct } from '../../ProductProvider'
import { UploadConfirmation } from './UploadConfirmation'
import { UploadPage } from './UploadPage'

export const UploadRouter: FunctionComponent = () => {
  const {
    product: { uploads },
  } = useProduct()

  return (
    <Routes>
      {Object.entries(uploads ?? {})?.map(([type, config]) => (
        <Route
          key={`upload-${type}`}
          path={type}
          element={<UploadPage type={type} config={config} />}
        />
      ))}
      <Route
        key='upload-confirmation'
        path='confirmation'
        element={<UploadConfirmation />}
      />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
